/**
 * Central query-key factory (frontend-architecture R4).
 * Every hook in apps/ui/web reads keys from here — no hand-spelled array
 * literals at call sites. Keys follow the PLAN §5.3.2 hierarchy:
 * [domain, sub-domain, ...identifiers].
 */
export const keys = {
  workstream: {
    all: () => ['workstream'] as const,
    createChat: () => ['workstream', 'create', 'chat'] as const,
    create: () => ['workstream', 'create'] as const,
  },
} as const;
